import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Label } from "../ui/label";
import { Badge } from "../ui/badge";

export function ConfirmationCard(props) {
  return (
    <Card className="flex flex-col justify-between ">
      <CardHeader>
        <CardTitle>{props.name}</CardTitle>
        <CardDescription>{props.monthYear}</CardDescription>
      </CardHeader>

      <CardContent></CardContent>
      <CardFooter className="flex justify-end">
        <Button type="submit" onClick={props.editClick}>
          Detayı Gör
        </Button>
      </CardFooter>
    </Card>
  );
}
